var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { Stack } from "@mui/material";
import { COLORS } from "../../../constants";
import Text from "../Text";
var CompanyLogo = function (_a) {
    var companyLogo = _a.companyLogo, companyTicker = _a.companyTicker, size = _a.size, sx = _a.sx;
    var sizeData = size === "lg"
        ? {
            diameter: 64,
            variant: "subtitle2",
            sx: {},
        }
        : {
            diameter: 32,
            variant: "caption",
            sx: { fontSize: "8px" },
        };
    return (_jsx(Stack, __assign({ sx: __assign({ height: sizeData.diameter, width: sizeData.diameter, alignItems: "center", justifyContent: "center", position: "relative", margin: "0 auto", border: "1px solid ".concat(COLORS.LIGHT_GREY), borderRadius: "100px", overflow: "hidden", backgroundColor: companyLogo || companyTicker ? COLORS.WHITE : COLORS.LIGHT_GREY }, sx) }, { children: companyLogo ? (_jsx("img", { src: companyLogo, width: "100%", height: "100%" })) : companyTicker ? (_jsx(Text, __assign({ variant: sizeData.variant, sx: sizeData.sx }, { children: companyTicker }))) : null })));
};
export default CompanyLogo;
